var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobilekeepStyle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M125.394 43.002H74.605a7.552 7.552 0 00-7.552 7.553v98.89a7.553 7.553 0 007.552 7.553h50.789a7.553 7.553 0 007.553-7.553v-98.89a7.554 7.554 0 00-7.553-7.553zm-33.509 5.483h16.229a1.052 1.052 0 110 2.106H91.885a1.052 1.052 0 110-2.106zM100 154.091a3.468 3.468 0 110-6.937 3.468 3.468 0 010 6.937zm27.66-10.776H72.339V54.636h55.321v88.679z",
    fill: "#690048"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobilekeepStyle);
export default __webpack_public_path__ + "static/media/mobile.keepStyle.dc042aa716fcc22b7ccb61031509eb5e.svg";
export { ForwardRef as ReactComponent };